import React from 'react'
import eventManager from '../../helpers/eventManager'
import { Redirect } from 'react-router-dom'


class RedirectContainer extends React.Component
{
    state = {
        url: null
    }

    createMessage = ({url, callback}) =>
    {
        this.setState({ url : url }, callback)
    }

    componentDidMount()
    {
        eventManager.listenEvent("REDIRECT", "redirect create", this.createMessage.bind(this))
    }

    render()
    {
        var redirectUrl = this.state.url

        if (redirectUrl == null)
        {
            return <React.Fragment></React.Fragment>
        }

        else
        {
            this.setState({ url: null })
        }

        return (
            <React.Fragment>
                <Redirect to={redirectUrl} />
            </React.Fragment>
        )
    }
}

export default RedirectContainer
